// router/index.js
// Diese Datei konfiguriert das clientseitige Routing der Anwendung.
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import MeView from '../views/MeView.vue'
import WetteView from '../views/WetteView.vue'
import ImpressumView from '../views/ImpressumView.vue'
import ChatsView from '../views/ChatsView.vue'
import BerechtigungView from '../views/BerechtigungView.vue'
import OnlineView from '../views/OnlineView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import PrivaterChatView from "../views/PrivaterChatView.vue";
import PodestView from "../views/PodestView.vue";
import PasswordVergessenView from "../views/PasswordVergessenView.vue";
import PrivacyView from "../views/PrivacyView.vue";

import { useAuth } from '../composables/useAuth'
import { watch } from 'vue'

// Definiert die Routen der Anwendung. Jede Route mappt einen URL-Pfad zu einer Komponente.
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { guestOnly: true },
  },
  {
    path: '/reset',
    name: 'Passwort im Eimer',
    component: PasswordVergessenView,
    meta: { guestOnly: true },
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: { guestOnly: true },
  },
  {
    path: '/me',
    name: 'Benutzereinstellungen',
    component: MeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/wetten/:id',
    name: 'WetteDetail',
    component: WetteView
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: ImpressumView
  },
  {
    path: '/privacy',
    name: 'Datenschutzerklärung',
    component: PrivacyView
  },
  {
    path: '/chat',
    name: 'Chat',
    component: ChatsView
  },
  {
    path: '/chat/:id',
    name: 'Spezieller Chat',
    component: ChatsView
  },
  {
    path: '/berechtigung',
    name: 'Berechtigung für Benachrichtung einfordern',
    component: BerechtigungView
  },
  {
    path: '/online',
    name: 'Alle aktiven Benutzer',
    component: OnlineView
  },
  {
    path: '/dm/:email',
    name: 'Direkte Nachrichten (Privater Chat)',
    component: PrivaterChatView
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => NotFoundView
  },
  {
    path: "/podest",
    name: "Die Erfolgreichsten Wetter",
    component: PodestView
  }
]

// Erstellt die Router-Instanz.
const router = createRouter({
  // `createWebHistory` aktiviert den "History Mode", der saubere URLs ohne Hash (#) ermöglicht.
  history: createWebHistory(process.env.BASE_URL),
  // Übergibt die definierten Routen an den Router.
  routes
})

const auth = useAuth()

// Globaler Navigation Guard: Wird vor jeder Navigation ausgeführt.
router.beforeEach(async (to) => { //vor dem laden der unterseite den Anmeldestatus vom backend abfragen
  if (to.meta.requiresAuth) {
    // Wenn die Route eine Authentifizierung erfordert, prüfe den Status.
    await auth.refreshAuth({ force: true })
    if (!auth.isAuthenticated.value) return '/login'
  }
  // Wenn die Route nur für Gäste ist und der Benutzer eingeloggt ist, leite zur Startseite um.
  if (to.meta.guestOnly && auth.isAuthenticated.value) return '/'
})
router.afterEach(() => void auth.refreshAuth());
router.afterEach(() => {
  const el = document.querySelector('.foreground')
  if (el) el.scrollTo({top: 0});
})

// Beobachtet den Benutzerstatus. Wenn der Benutzer sich ausloggt, während er sich
// auf einer geschützten Seite befindet, wird er zur Startseite weitergeleitet.
watch(() => auth.user.value, (user) => {
    if (!user) {
      const currentRoute = router.currentRoute.value
      if (currentRoute.meta?.requiresAuth) router.push('/')
    } else {
      try {
          if(("needPermissionNotification" in window) && window.needPermissionNotification) {
              window.needPermissionNotification = false;
              router.push('/berechtigung');
          }
      } catch(e) {
        console.log(e);
      }
    }
  }
)

export default router